<div class="modal-header">
  <div class="d-flex justify-content-between align-items-center w-100">
    <h5 class="modal-title fw-bold">{{title}}</h5>
    <button type="button" class="btn btn-link shadow-none px-0 text-dark" (click)="close()">
      <i-bs name="x" width="1em" height="1em"></i-bs>
    </button>
  </div>
</div>
<div class="modal-body">
  <form [formGroup]="transferRequestStatusForm" (ngSubmit)="save()">
    <input type="hidden" formControlName="id">


    <div class="row mb-3">
      <label class="col-sm-3 col-form-label" for="isPrincipalApproved1">Status</label>
      <div class="col-sm-7">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" formControlName="isPrincipalApproved" name="isPrincipalApproved"
            id="isPrincipalApproved1" [value]="true">
          <label class="form-check-label" for="isPrincipalApproved1">Approve</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" formControlName="isPrincipalApproved" name="isPrincipalApproved"
            id="isPrincipalApproved2" [value]="false">
          <label class="form-check-label" for="isPrincipalApproved2">Reject</label>
        </div>
        <my-error controlName="isPrincipalApproved" errorKey="required">Status is required.</my-error>
      </div>
    </div>
    <div class="row mb-3">
      <label class="col-sm-3 col-form-label" for="principalRemark">Remark</label>
      <div class="col-sm-7">
        <textarea MyInput formControlName="principalRemark" class="form-control" rows="2"></textarea>
        <my-error controlName="principalRemark" errorKey="required">Remark is required.</my-error>
      </div>
    </div>

    <div class="d-flex">
      <button class="btn btn-primary rounded-0 ml-auto mr-2" [disabled]="!transferRequestStatusForm.valid || loading"
        type="submit">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
        Submit
      </button>
    </div>
  </form>
</div>